import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import "../styles/globals/_globals.scss";
import "../styles/components/SectionOfferButtons.css";

import offerLongtime from "../assets/icons-fleet/icon-offer-longtime.svg";
// import offerShorttime from "../assets/icons-fleet/icon-offer-shortime.svg";
import offerSell from "../assets/icons-fleet/icon-offer-sell.svg";
import offerFleet from "../assets/icons-fleet/icon-offer-fleet.svg";

import arrowRightSmall from "../assets/images/icons/svg/arrow-small-orange.svg";

const SectionOfferButtons = ({ type }) => {
  return (
    <div className="section-offer-buttons">
      <div className="container container-small">
        <ul className="row">
          {type !== "long" && (
            <li className="col long">
              <Link className="btn-offer" to="/oferta/wynajem-dlugookresowy">
                <img src={offerLongtime} alt="Icon" className="icon-offer" />
                <h5>
                  Wynajem
                  <br />
                  długoterminowy
                </h5>
                <img
                  src={arrowRightSmall}
                  alt="Icon arrow right orange"
                  className="arrow-icon"
                />
              </Link>
            </li>
          )}
          {/* {type !== "short" && (
            <li className="col short">
              <Link className="btn-offer" to="/oferta/wynajem-krotkookresowy">
                <img src={offerShorttime} alt="Icon" className="icon-offer" />
                <h5>
                  Wynajem
                  <br />
                  krótkoterminowy
                </h5>
                <img
                  src={arrowRightSmall}
                  alt="Icon arrow right orange"
                  className="arrow-icon"
                />
              </Link>
            </li>
          )} */}
          {type !== "sell" && (
            <li className="col sell">
              <Link className="btn-offer" to="/oferta/sprzedaz">
                <img src={offerSell} alt="Icon" className="icon-offer" />
                <h5>
                  <br />
                  Zakup
                </h5>
                <img
                  src={arrowRightSmall}
                  alt="Icon arrow right orange"
                  className="arrow-icon"
                />
              </Link>
            </li>
          )}
          {type !== "fleet" && (
            <li className="col sell">
              <Link className="btn-offer" to="/oferta/obsluga-flot">
                <img src={offerFleet} alt="Icon" className="icon-offer" />
                <h5>
                  <br />
                  Obsługa flot
                </h5>
                <img
                  src={arrowRightSmall}
                  alt="Icon arrow right orange"
                  className="arrow-icon"
                />
              </Link>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

SectionOfferButtons.propTypes = {
  type: PropTypes.oneOf(["all", "short", "long", "sell", "fleet", "cars"])
};

export default SectionOfferButtons;
